// Template for check box
export default function() {

  let check = "<svg style=\"top: 35%; left: 16px;\" width=\'20\' height=\'20\' "
  check += "class=\'position-absolute checkbox-svg clickable\' viewBox=\'0 0 20 20\' fill=\'none\' "
  check += "xmlns=\'http://www.w3.org/2000/svg\'>";
  check += "<g id=\'Tick Small\'><path id=\'Vector\' d=\'M5.33334 10.6251L8.08334 13.3333L14.6667 6.66667\' ";
  check += "stroke=\'white\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'></path></g></svg>";

  return check;

}
